<template>
  <div class="tab-table">
    <simple-table
      category="assistants"
      :columns="columns"
      :loading="loading"
      :error="error"
      :list="list"
      @rowClick="rowClick"
      @fetch="handleFetch"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/common/SimpleTable';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'assistants-table',

  components: {
    SimpleTable,
  },

  data() {
    return {
      columns: [
        { label: 'Название', name: 'title', width: '15%' },
        { label: 'Краткая информация', name: 'short_info', width: '15%' },
        { label: 'Описание', name: 'description', width: '55%' },
        { label: 'Изображение', name: 'image_url', width: '15%' },
      ],
    };
  },

  watch: {
    params: {
      deep: true,
      handler: function() {
        this.fetch();
      },
    },
  },

  computed: {
    ...mapGetters({
      loading: 'assistants/loading',
      params: 'assistants/params',
      error: 'assistants/error',
      list: 'assistants/list',
    }),
  },

  methods: {
    ...mapActions({
      fetch: 'assistants/fetch',
    }),

    rowClick(id) {
      this.$router.push({
        name: `assistants-item`,
        params: {
          id,
        },
      });
    },

    handleFetch() {
      this.fetch();
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-table {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>
